import { useMemo } from "react";

import { useSwrFetch } from "./useSwrFetch";

import type { CompanyReviewProfile } from "types/company";

interface UseCompanyReviewsProps {
  companyId: number;
}

export function useCompanyReviews(props: UseCompanyReviewsProps) {
  const { companyId } = props;

  const url = useMemo(
    () => (companyId ? `/companies/${companyId}/public-reviews` : null),
    [companyId],
  );

  const {
    data: reviewProfile,
    loading,
    error,
    refetch: refetchReviews,
  } = useSwrFetch<CompanyReviewProfile>({
    url,
    errorMessage: "Failed to fetch company reviews",
  });

  return {
    error,
    loading,
    reviewProfile: reviewProfile ?? null,
    refetchReviews,
  };
}
